import { useMsal } from "@azure/msal-react";
import { Button } from "src/components/ui/button";

interface SignInScreenProps {}

const SignInScreen = () => {
	const { instance } = useMsal();

	return (
		<div className="flex min-h-screen items-center justify-center bg-subtle px-4">
			<div className="w-full max-w-[400px] flex flex-col items-center rounded-xl bg-card border border-border p-6 shadow-lg">
				<img src="/mee-logo.svg" alt="Mee" className="h-8 mb-8" />

				<p className="text-caption text-muted-foreground mb-8">
					Sign in to access My Employee Experience
				</p>

				<Button className="w-full" onClick={() => instance.loginRedirect()}>
					Sign in
				</Button>
			</div>
		</div>
	);
};

export { SignInScreen, type SignInScreenProps };
